import type {
  CampaignTemplatesQueryResponse,
  CampaignTemplatesQueryVariables,
} from '~/api/graphql/queries/campaignTemplates.generated';
import type { UseInfiniteQueryOptions } from '@tanstack/react-query';

import { CampaignTemplatesDocument } from '~/api/graphql/queries/campaignTemplates.generated';
import { useInfiniteQuery } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils';

const INFINITE_KEY = 'campaign-templates-infinite';

export const useInfiniteCampaignTemplates = <TError = unknown>(
  variables: CampaignTemplatesQueryVariables,
  options?: Omit<
    UseInfiniteQueryOptions<CampaignTemplatesQueryResponse, TError, CampaignTemplatesQueryResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useInfiniteQuery<CampaignTemplatesQueryResponse, TError>(
    [INFINITE_KEY, variables],
    (args) =>
      appFetcher<CampaignTemplatesQueryResponse, CampaignTemplatesQueryVariables>(
        CampaignTemplatesDocument,
        {
          ...variables,
          after: args.pageParam ?? null,
        },
      )(),
    options,
  );
};
useInfiniteCampaignTemplates.getKey = (variables: CampaignTemplatesQueryVariables) => [
  INFINITE_KEY,
  variables,
];
